module.exports = __webpack_public_path__ + "c0bdb1a8a77eb133c4b7b4d4391d5ad4.svg";